<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Users"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="first_name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.first_name"
                  label="Nombres"
                  prepend-inner-icon="fas fa-user"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="last_name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.last_name"
                  label="Apellidos"
                  prepend-inner-icon="fas fa-user"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider
                ref="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.email"
                  label="E-mail"
                  prepend-inner-icon="fas fa-envelope"
                ></v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col>
              <ValidationProvider
                ref="password"
                rules="min:4"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.password"
                  label="Password"
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'fas fa-eye' : 'fas fa-eye-slash'"
                  @click:append="show1 = !show1"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider
                ref="gender"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :error-messages="errors"
                  v-model="data.gender"
                  prepend-inner-icon="fas fa-user-tag"
                  :items="genders"
                  item-text="name"
                  item-value="value"
                  label="Género"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider
                ref="type"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :error-messages="errors"
                  v-model="data.type"
                  prepend-inner-icon="fas fa-user-tag"
                  :items="types"
                  item-text="name"
                  item-value="id"
                  label="Tipo de Usuario"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="phone" rules="" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  v-model="data.phone"
                  label="Teléfono"
                  prepend-inner-icon="fas fa-mobile"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider
                ref="profile_picture"
                rules=""
                v-slot="{ errors }"
              >
                <Upload
                  :error-messages="errors"
                  accept="image/png, image/jpeg, image/jpg"
                  placeholder="Imagen de Perfil"
                  prepend-icon="fas fa-camera"
                  label=""
                  :multiple="false"
                  :onSelectedPicture="onSelectedPicture"
                ></Upload>
                <v-img
                  :src="profile_picture"
                  width="200"
                  style="margin: auto"
                ></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },

  data() {
    return {
      storeName: "Users",
      title: "Usuario",
      filteredAttributes: ["profile_picture"],
      genders: [
        { name: "Hombre", value: "male" },
        { name: "Mujer", value: "female" }
      ],
      show1: false,
      profile_picture: "",
      data: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        phone: "",
        about: "",
        type: "",
        profile_picture: undefined,
        document_type: "",
        document: "",
        role: "",
        country_id: undefined,
        state_id: undefined,
        address: "",
        level: "",
        gender: "male"
      }
    };
  },
  computed: {
    ...mapState({
      status: state => state.Users.status,
      types: state => state.Users.types,
      countries: state => state.Countries.list
    })
  },
  watch: {
    "data.country_id": {
      handler(element) {
        if (element) {
          this.$store.dispatch("States/getListAll", {
            show_all: "enable",
            sorting_column: "name",
            sorting_order: "asc",
            country_id: element
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    onSelectedPicture(file) {
      const self = this;
      this.data.profile_picture = file;

      let fr = new FileReader();
      fr.onload = function() {
        self.profile_picture = fr.result;
      };
      fr.onerror = function() {
        self.profile_picture = "";
      };
      fr.readAsDataURL(this.data.profile_picture);
    }
  }
};
</script>
